import { apiClient } from "../../../services/axiosInstance";
import { ServerSingleResponse } from "../../../types";
import { FeedSuggestionResults } from "../types";
import { FeedMode } from "../../../hookstate/feedModeStore";

export const GET_FEED_SUGGESTION_QUERY_KEY = ["feed-suggestion"];

export function getFeedSuggestion(
  seed: string | null,
  cursor: string | null,
  perPage = 12,
  mode: FeedMode = "mixed",
) {
  // Empty seed → backend falls back to the top-popular LTR comic. Used by the
  // navbar entry so the user can drop into a feed without picking a comic.
  const params = new URLSearchParams({ perPage: String(perPage) });
  if (seed) params.set("seed", seed);
  if (cursor) params.set("cursor", cursor);
  // Omit the default so URLs stay clean for the common case.
  if (mode !== "mixed") params.set("mode", mode);

  return apiClient.get<ServerSingleResponse<FeedSuggestionResults>>(
    `/v1/feed/suggestion?${params.toString()}`,
  );
}
